var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5746 16.9986L10.8076 12.2326C9.76669 12.9192 8.50802 13.1952 7.27531 13.0071C6.0426 12.8189 4.92357 12.18 4.13491 11.2141C3.34625 10.2482 2.94407 9.02401 3.00627 7.77858C3.06847 6.53315 3.59061 5.3551 4.47158 4.47258C5.35395 3.59127 6.53198 3.06879 7.77752 3.00632C9.02306 2.94386 10.2475 3.34586 11.2136 4.13446C12.1797 4.92306 12.8188 6.04214 13.007 7.27496C13.1953 8.50777 12.9193 9.76658 12.2326 10.8076L16.9976 15.5756L15.5746 16.9986ZM8.03158 5.01258C7.23063 5.01204 6.46227 5.32971 5.89553 5.8957C5.3288 6.46168 5.01011 7.22962 5.00958 8.03057C5.00905 8.83153 5.32672 9.59989 5.8927 10.1666C6.45869 10.7334 7.22663 11.052 8.02758 11.0526C8.42417 11.0528 8.81693 10.975 9.18344 10.8235C9.54994 10.6719 9.88301 10.4497 10.1636 10.1695C10.4442 9.8892 10.6669 9.55643 10.8189 9.19013C10.9709 8.82382 11.0493 8.43117 11.0496 8.03458C11.0498 7.63798 10.972 7.24522 10.8205 6.87872C10.6689 6.51222 10.4467 6.17915 10.1665 5.89853C9.88621 5.61791 9.55343 5.39524 9.18713 5.24322C8.82083 5.09121 8.42817 5.01284 8.03158 5.01258Z",
    fill: "#AABED9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.44350ca4e5e4e1de3c3d065841feb82e.svg";
export { ForwardRef as ReactComponent };